export const NOTIFICATIONS_SET = "NOTIFICATIONS.SET";
export const NOTIFICATIONS_SET_VISUALIZED = "NOTIFICATIONS.SET_VISUALIZED";
export const NOTIFICATIONS_CLEAR_ALL = "NOTIFICATIONS.CLEAR_ALL";
export const NOTIFICATIONS_GET = "NOTIFICATIONS.GET";